<template>
  <div>
    <Ibox :titulo="'Filtros'">
      <FormGroup
        cols="4"
        label="Habilitado">
        <v-select 
          v-model="habilitado"
          :clearable=false
          :options="[{v:'',label:'Todo'},{v:'S',label:'Si'},{v:'N',label:'No'}]" 
          :reduce="habilitado=>habilitado.v">
        </v-select>
      </FormGroup>
      <b-col cols="12">
        <b-button v-if="loading_tabla" style="float:right" variant="primary"><Loading :size="'1'" :text="'Cargando datos'"/></b-button>
        <b-button v-else variant="primary" style="float:right" v-on:click="cargarDatos()">Cargar</b-button>
      </b-col>
    </Ibox>
    <Ibox :titulo="'Usuarios'">
      <b-col cols="12">
        <b-card class="mb-2" header="Ayuda" header-bg-variant="warning" header-text-variant="white">
          <b-card-text>
            <p>En éste menú se puede crear, habilitar o deshabilitar usuarios y asignar perfiles (Inspector, ejecutor, administrador sucursal, administrador y trabajador con documentos).</p>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="12">
        <h2 v-if="!loading_max_usuarios">Su plan actual permite tener <span style="color:red">{{ maximo_usuarios }} </span> Usuarios y <span style="color:red">{{ maximo_usuarios_trabajador }} </span> Usuarios trabajador</h2>
        <b-skeleton style="margin-bottom:10px" type="input" v-else></b-skeleton> 
      </b-col>
      <b-col cols="12">
        <DataTable
          :loading="loading_tabla"
          :columns="columns"
          :rows="rows">
          <div slot="table-actions">
            <router-link 
              class="btn btn-primary btn-sm" 
              v-if="utils.tienePermiso()"
              tag="button" 
              :to="{ name: 'usuario/agregar' }">Agregar usuario
            </router-link>
          </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action' && utils.tienePermiso()">
            <a href="javascript:void(0)" v-on:click="openModalHistorial( props.row )">Historial</a>
            |
            <a href="javascript:void(0)" v-on:click="openModalInformacion( props.row )">Información</a>
            |
            <a href="javascript:void(0)" v-on:click="openModalSucursales( props.row )">Sucursales</a>
            |
            <a href="javascript:void(0)" v-on:click="modalPass( props.row )">Contraseña</a>
            |
            <router-link :to="{ name: 'usuario/editar', params: { usuario:utils.je64(props.row) } }">Editar</router-link>
          </span>
           <span v-else-if="props.column.field == 'perfiles'">
              {{ columnaPerfiles(props.row) }}
            </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        </DataTable>
      </b-col>
    </Ibox>
    <b-modal hide-footer ref="modal_pass" title="Cambiar contraseña">
      <FormGroup
        cols="12"
        label="Nueva contraseña">
        <input type="password" class="form-control" autoComplete="new-password" v-model="pass">
      </FormGroup>
      <FormGroup
        cols="12"
        label="Repita contraseña">
        <input type="password" class="form-control" autoComplete="new-password" v-model="repita_pass">
      </FormGroup>
      <b-button v-if="!loading_pass" variant="primary" style="width:100%" v-on:click="cambiarPass">Cambiar contraseña</b-button>
      <b-button v-else variant="primary" style="width:100%"><Loading :text="'Cambiando contraseña'" :size="1"/></b-button>
    </b-modal>
    <b-modal size="xl" hide-footer ref="modal_informacion" :title="modal_informacion.usuario.nombre_usuario">
      <ModalInformacion :usuario=modal_informacion.usuario></ModalInformacion>
    </b-modal>
    <b-modal size="xl" hide-footer ref="modal_historial" :title="modal_historial.usuario.nombre_usuario">
      <ModalHistorial :usuario=modal_historial.usuario></ModalHistorial>
    </b-modal>
    <b-modal size="xl" hide-footer ref="modal_sucursales" :title="modal_sucursales.usuario.nombre_usuario">
      <ModalSucursales :usuario=modal_sucursales.usuario></ModalSucursales>
    </b-modal>
  </div>
</template>

<script>
import { userService } from '@/services';
import { utils } from '@/helpers';
import { clienteService } from '../../services';

import ModalHistorial from './Historial.vue';
import ModalInformacion from './Informacion.vue';
import ModalSucursales from './Sucursales.vue';

var sha1 = require('js-sha1');

export default {
  components: { 
    ModalHistorial,
    ModalInformacion,
    ModalSucursales 
  },
  data(){
    return {
      maximo_usuarios:0,
      maximo_usuarios_trabajador:0,
      utils,
      habilitado:'S',
      loading_tabla: true,
      loading_max_usuarios: true,
      loading_pass:false,
      pass:'',
      repita_pass:'',
      usuario:null,
      columns:[
        {label: 'Nombre', field: 'nombre_usuario'},
        {label: 'Correo', field: 'correo'},
        {label: 'Habilitado', field: 'desc_habilitado'},
        {label: 'Perfiles', field:'perfiles'},
        {label: 'Permisos', field: 'desc_permiso'},
        {label: 'Acciones', field: 'action'}
        ],
      rows:[],
      modal_informacion: {
        usuario:{
          nombre_usuario :''
        }
      },
      modal_historial: {
        usuario:{
          nombre_usuario :''
        }
      },
      modal_sucursales: {
        usuario:{
          nombre_usuario :''
        }
      },
    }
  },
  mounted () {
    this.cargarDatos();
  },
  methods : {
    openModalHistorial(row){
      this.modal_historial.usuario = row;

      this.$refs['modal_historial'].show();
    },
    openModalInformacion(row){
      this.modal_informacion.usuario = row;

      this.$refs['modal_informacion'].show();
    },
    openModalSucursales(row){
      this.modal_sucursales.usuario = row;

      this.$refs['modal_sucursales'].show();
    },
    columnaPerfiles(row){
      let perfiles = JSON.parse(row.perfiles);

      if(row.admin_categoria > 0){
        if(perfiles == null){
          perfiles = [];
        }

        perfiles.push({
          'id_perfil':1,
          'nombre_perfil':'Administrador categoria'
        });
      }

      if(perfiles != null){
        if(perfiles.length == 1){
          return perfiles[0].nombre_perfil;
        }
        return perfiles.reduce(function(total, perfil){
          if ( total.nombre_perfil ) {
            total = total.nombre_perfil +  ', ' + perfil.nombre_perfil;
          } else {
            total = total + ', ' + perfil.nombre_perfil;
          }
          return total;
        });
      }else{
        return "";
      }
    },
    cargarDatos(){
      this.loading_tabla = true;
      this.loading_max_usuarios = true;

      userService.getUsuarios({
        habilitado:this.habilitado
      }).then(data => {
        this.rows = data.data;

        this.loading_tabla = false;
      });

      clienteService.getClienteMaximosUsuarios({
        id_cliente:this.$store.state.usuario.id_cliente
      }).then(data => {
        if(data.status == 'success'){
          this.maximo_usuarios = data.data.usuarios;
          this.maximo_usuarios_trabajador = data.data.usuarios_trabajador ?? 0;
        }
        this.loading_max_usuarios = false;
      });
    },
    modalPass(usuario){
      this.usuario = usuario;
      this.pass = '';
      this.repita_pass = '';

      this.$refs['modal_pass'].show();
    },
    cambiarPass(){
      if(this.pass.length >= 8){
        if(this.pass){
          if(this.pass == this.repita_pass){
            this.loading_pass = true;

            userService.putUsuarioPass({
              id_usuario: this.usuario.id_usuario,
              pass: sha1(this.pass)
            }).then(respuesta => {
              utils.alerta(respuesta);
              this.loading_pass = false;
              this.$refs['modal_pass'].hide();
            });
          }else{
            utils.alerta({msg:'Contraseñas deben ser iguales', status:'warning'});
          }
        }else{
          utils.alerta({msg:'Faltan campos obligatorios', status:'warning'});
        }
      }else{
        utils.alerta({msg:'La contraseña debe contener 8 caracteres como minimo', status:'warning'});
      }
    }
  }
}
</script>

<style scoped>

</style>
